import {IDependency} from '@mintdata-wsp/common/controllers/artifacts/VisualComponentsLoader';
import {VisualArtifactRef} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualArtifactRef';
import {VisualComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualComponent';

export class VisualArtifact
{
    constructor(public readonly ref:VisualArtifactRef,
                public readonly visualComponents:Array<VisualComponent>,
                public readonly dependencies:Array<IDependency> = [])
    {
    }
}
